// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Club roster board — federation-sheet density on desktop, member cards on mobile. */
.um-board {
  --um-pine: var(--brand-primary, #0877bc);
  --um-ink: var(--brand-primary-dark, var(--brand-primary, #0877bc));
  --um-slate: color-mix(in srgb, var(--brand-primary, #0877bc) 38%, #1e293b);
  --um-tape: color-mix(in srgb, #fff 90%, var(--brand-primary, #0877bc));
  --um-surface: color-mix(in srgb, var(--surface-color, #fff) 92%, var(--brand-primary, #0877bc));
  --um-line: color-mix(in srgb, var(--border-color, #e2e8f0) 70%, var(--brand-primary, #0877bc));
  --um-muted: var(--text-secondary, #64748b);
  --um-ok: #0f9f6e;
  --um-warn: #d97706;
  --um-info: #0284c7;
  --um-danger: #dc2626;
  --um-gone: #6b7280;
  --um-ease: cubic-bezier(0.22, 1, 0.36, 1);
  --um-display: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  --um-body: "IBM Plex Sans", Poppins, system-ui, sans-serif;

  position: relative;
  isolation: isolate;
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0 auto;
  padding:
    max(0.75rem, env(safe-area-inset-top, 0px))
    max(1rem, env(safe-area-inset-right, 0px))
    calc(1.75rem + env(safe-area-inset-bottom, 0px))
    max(1rem, env(safe-area-inset-left, 0px));
  color: var(--text-color);
  font-family: var(--um-body);
}

.um-board *,
.um-board *::before,
.um-board *::after {
  box-sizing: border-box;
}

.um-board__glow {
  pointer-events: none;
  position: absolute;
  z-index: -1;
  inset: -6% -12% auto;
  height: 160px;
  opacity: 0.75;
  background:
    radial-gradient(50% 70% at 6% 20%, color-mix(in srgb, var(--um-pine) 16%, transparent) 0%, transparent 70%),
    radial-gradient(36% 50% at 94% 0%, color-mix(in srgb, var(--um-pine) 10%, transparent) 0%, transparent 68%);
}

.um-hero {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.85rem 1.25rem;
  margin-bottom: 1rem;
}

.um-hero__copy {
  min-width: 0;
  max-width: 42rem;
}

.um-hero__kicker {
  margin: 0 0 0.2rem;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--um-muted);
}

.um-hero__title {
  margin: 0;
  font-family: var(--um-display);
  font-size: clamp(1.85rem, 3.2vw, 2.55rem);
  font-weight: 700;
  line-height: 0.95;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--um-ink);
}

.um-hero__sub {
  margin: 0.45rem 0 0;
  font-size: 0.9rem;
  line-height: 1.4;
  color: var(--um-muted);
  max-width: 36rem;
}

.um-hero__stats {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.um-stat {
  appearance: none;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 5.5rem;
  max-width: 8.5rem;
  padding: 0.55rem 0.75rem;
  border-radius: 12px;
  border: 1px solid var(--um-line);
  background: color-mix(in srgb, var(--surface-color, #fff) 88%, transparent);
  backdrop-filter: blur(8px);
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: inherit;
  transition:
    border-color 0.18s var(--um-ease),
    background 0.18s var(--um-ease),
    box-shadow 0.18s var(--um-ease),
    transform 0.18s var(--um-ease);
}

.um-stat:hover {
  border-color: color-mix(in srgb, var(--um-pine) 42%, var(--um-line));
  background: color-mix(in srgb, var(--um-pine) 8%, var(--surface-color, #fff));
}

.um-stat:active {
  transform: scale(0.98);
}

.um-stat.is-active {
  border-color: color-mix(in srgb, var(--um-pine) 55%, var(--um-line));
  background: color-mix(in srgb, var(--um-pine) 12%, var(--surface-color, #fff));
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--um-pine) 22%, transparent);
}

.um-stat--coaches {
  border-color: color-mix(in srgb, #6d28d9 35%, var(--um-line));
}

.um-stat--coaches.is-active {
  border-color: color-mix(in srgb, #6d28d9 55%, var(--um-line));
  background: color-mix(in srgb, #6d28d9 12%, var(--surface-color, #fff));
  box-shadow: 0 0 0 2px color-mix(in srgb, #6d28d9 22%, transparent);
}

.um-stat--competition {
  border-color: color-mix(in srgb, #2563eb 35%, var(--um-line));
}

.um-stat--competition.is-active {
  border-color: color-mix(in srgb, #2563eb 55%, var(--um-line));
  background: color-mix(in srgb, #2563eb 12%, var(--surface-color, #fff));
  box-shadow: 0 0 0 2px color-mix(in srgb, #2563eb 22%, transparent);
}

.um-stat--leisure {
  border-color: color-mix(in srgb, #0f9f6e 35%, var(--um-line));
}

.um-stat--leisure.is-active {
  border-color: color-mix(in srgb, #0f9f6e 55%, var(--um-line));
  background: color-mix(in srgb, #0f9f6e 12%, var(--surface-color, #fff));
  box-shadow: 0 0 0 2px color-mix(in srgb, #0f9f6e 22%, transparent);
}

.um-stat--health {
  border-color: color-mix(in srgb, #d97706 35%, var(--um-line));
}

.um-stat--health.is-active {
  border-color: color-mix(in srgb, #d97706 55%, var(--um-line));
  background: color-mix(in srgb, #d97706 12%, var(--surface-color, #fff));
  box-shadow: 0 0 0 2px color-mix(in srgb, #d97706 22%, transparent);
}

.um-stat--invited {
  border-color: color-mix(in srgb, #0284c7 35%, var(--um-line));
}

.um-stat--form {
  border-color: color-mix(in srgb, #9e2b2b 35%, var(--um-line));
}

.um-stat--form.is-active {
  border-color: color-mix(in srgb, #9e2b2b 55%, var(--um-line));
  background: color-mix(in srgb, #9e2b2b 10%, var(--surface-color, #fff));
  box-shadow: 0 0 0 2px color-mix(in srgb, #9e2b2b 18%, transparent);
}

.um-stat--invited.is-active {
  border-color: color-mix(in srgb, #0284c7 55%, var(--um-line));
  background: color-mix(in srgb, #0284c7 12%, var(--surface-color, #fff));
  box-shadow: 0 0 0 2px color-mix(in srgb, #0284c7 22%, transparent);
}

.um-stat__value {
  font-family: var(--um-display);
  font-size: 1.55rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.02em;
  color: var(--um-pine);
}

.um-stat__label {
  margin-top: 0.25rem;
  font-size: 0.64rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--um-muted);
  line-height: 1.25;
}

.um-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 0.9rem;
  padding: 0.7rem;
  border-radius: 16px;
  border: 1px solid var(--um-line);
  background:
    linear-gradient(
      135deg,
      color-mix(in srgb, var(--um-pine) 6%, transparent),
      transparent 55%
    ),
    color-mix(in srgb, var(--surface-color, #fff) 92%, transparent);
}

.um-search {
  position: relative;
  flex: 1 1 14rem;
  min-width: 0;
}

.um-search__icon {
  position: absolute;
  left: 0.85rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--um-muted);
  font-size: 0.85rem;
  pointer-events: none;
}

.um-search__input {
  width: 100%;
  height: 2.65rem;
  padding: 0 0.9rem 0 2.35rem;
  border-radius: 999px;
  border: 1px solid var(--um-line);
  background: var(--bg-color, #fff);
  color: var(--text-color);
  font: 500 0.92rem/1.2 var(--um-body);
  outline: none;
  transition: border-color 0.2s var(--um-ease), box-shadow 0.2s var(--um-ease);
}

.um-search__input:focus {
  border-color: color-mix(in srgb, var(--um-pine) 55%, var(--um-line));
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--um-pine) 18%, transparent);
}

.um-search__input::placeholder {
  color: var(--um-muted);
  opacity: 0.85;
}

.um-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin-left: auto;
}

.um-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 2.55rem;
  padding: 0.55rem 1rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font: 600 0.82rem/1 var(--um-body);
  letter-spacing: 0.01em;
  cursor: pointer;
  text-decoration: none;
  white-space: nowrap;
  transition: transform 0.18s var(--um-ease), background 0.18s var(--um-ease),
    border-color 0.18s var(--um-ease), color 0.18s var(--um-ease);
}

.um-btn:active {
  transform: scale(0.98);
}

.um-chip--form {
  border: 1px solid #9e2b2b;
  background: transparent;
  color: #9e2b2b;
  cursor: pointer;
  font: inherit;
  font-size: 12px;
  padding: 2px 8px;
  margin-top: 4px;
}

.um-chip--newcomer {
  border: 0;
  cursor: pointer;
  background: #12362c;
  color: #f3f6f4;
  font: inherit;
  font-size: 12px;
  padding: 2px 8px;
  margin-top: 4px;
}

.um-btn--primary {
  background: var(--um-pine);
  color: #fff;
  box-shadow: 0 8px 18px color-mix(in srgb, var(--um-pine) 28%, transparent);
}

.um-btn--primary:hover {
  filter: brightness(1.05);
  color: #fff;
}

.um-btn--ghost {
  background: transparent;
  border-color: var(--um-line);
  color: var(--um-slate);
}

.um-btn--ghost:hover {
  border-color: color-mix(in srgb, var(--um-pine) 40%, var(--um-line));
  background: color-mix(in srgb, var(--um-pine) 8%, transparent);
  color: var(--um-ink);
}

.um-sort {
  display: none;
  gap: 0.4rem;
  width: 100%;
  overflow-x: auto;
  padding-bottom: 0.15rem;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.um-sort::-webkit-scrollbar {
  display: none;
}

.um-sort__chip {
  appearance: none;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  min-height: 2rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  border: 1px solid var(--um-line);
  background: var(--bg-color, #fff);
  color: var(--um-muted);
  font: 600 0.75rem/1 var(--um-body);
  cursor: pointer;
}

.um-sort__chip.is-active {
  border-color: color-mix(in srgb, var(--um-pine) 45%, var(--um-line));
  background: color-mix(in srgb, var(--um-pine) 12%, transparent);
  color: var(--um-ink);
}

/* ── Desktop table ─────────────────────────────────────────────────── */
.um-table-wrap {
  display: none;
  width: 100%;
  overflow: auto;
  border-radius: 18px;
  border: 1px solid var(--um-line);
  background: color-mix(in srgb, var(--surface-color, #fff) 94%, transparent);
  box-shadow: 0 10px 28px color-mix(in srgb, var(--um-slate) 8%, transparent);
  -webkit-overflow-scrolling: touch;
}

.um-table {
  width: 100%;
  min-width: 1080px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: auto;
}

.um-table thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 0.85rem 0.9rem;
  text-align: left;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--um-muted);
  background: color-mix(in srgb, var(--surface-color, #fff) 88%, var(--um-pine));
  border-bottom: 1px solid var(--um-line);
  white-space: nowrap;
}

.um-table th.um-col--name,
.um-table td.um-col--name {
  min-width: 16rem;
  width: 22%;
  max-width: 22rem;
}

.um-table th.um-th--sort {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.um-table th.um-th--sort:hover {
  color: var(--um-ink);
}

.um-th__inner {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.um-table tbody td {
  padding: 0.85rem 0.9rem;
  vertical-align: middle;
  border-bottom: 1px solid color-mix(in srgb, var(--um-line) 70%, transparent);
  font-size: 0.88rem;
}

.um-table tbody tr {
  transition: background 0.18s var(--um-ease);
}

.um-table tbody tr:hover td {
  background: color-mix(in srgb, var(--um-pine) 6%, transparent);
}

.um-table tbody tr.is-deleted {
  opacity: 0.72;
}

.um-table tbody tr:last-child td {
  border-bottom: 0;
}

.um-identity {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
}

.um-avatar {
  position: relative;
  flex: 0 0 auto;
  width: 2.55rem;
  height: 2.55rem;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-family: var(--um-display);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: #fff;
  background: var(--um-pine);
  box-shadow: 0 0 0 2px color-mix(in srgb, #fff 70%, transparent);
}

.um-avatar--awaiting,
.um-avatar--invited {
  background: var(--um-warn);
}

.um-avatar--deleted {
  background: var(--um-gone);
}

.um-avatar__rank {
  position: absolute;
  right: -0.2rem;
  bottom: -0.2rem;
  min-width: 1.35rem;
  height: 1.15rem;
  padding: 0 0.28rem;
  border-radius: 999px;
  display: grid;
  place-items: center;
  font-family: var(--um-display);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff;
  border: 1.5px solid var(--bg-color, #fff);
}

.um-identity__text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.um-identity__name {
  margin: 0;
  font-family: var(--um-display);
  font-size: 1.12rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.2;
  color: var(--text-color);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  overflow-wrap: break-word;
  word-break: normal;
  hyphens: manual;
}

.um-identity-wrap {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.35rem;
}

.um-identity__meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
  padding-left: 3.3rem;
}

.um-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 1.25rem;
  padding: 0.12rem 0.5rem;
  border-radius: 999px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
  color: #fff;
}

.um-chip--awaiting {
  background: var(--um-warn);
}

.um-chip--invited {
  background: var(--um-info);
}

.um-chip--deleted {
  background: var(--um-gone);
}

.um-chip--active {
  background: var(--um-ok);
}

.um-chip--inactive {
  background: var(--um-danger);
}

.um-guest-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.3rem;
}

.um-chip--guest-visits {
  background: rgba(40, 80, 120, 0.14);
  color: #1e3a5f;
}

.um-chip--guest-license {
  background: rgba(190, 40, 40, 0.16);
  color: #b42318;
  font-weight: 700;
}

.um-chip--guest-pending {
  background: rgba(180, 120, 20, 0.18);
  color: #8a5a00;
}

.um-chip--role {
  background: var(--um-slate);
}

.um-rank {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 2.2rem;
  padding: 0.28rem 0.55rem;
  border-radius: 8px;
  font-family: var(--um-display);
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  color: #fff;
}

.um-rank--a {
  background: #0f9f6e;
}

.um-rank--b {
  background: #2563eb;
}

.um-rank--c {
  background: #d97706;
}

.um-rank--d,
.um-rank--other {
  background: #dc2626;
}

.um-points {
  font-family: var(--um-display);
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--um-pine);
}

.um-points-wrap {
  display: inline-flex;
  align-items: baseline;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.um-place {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--um-muted);
  letter-spacing: 0.02em;
}

.um-week-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.um-week-chip--up {
  color: #0f7a32;
  background: rgba(16, 185, 129, 0.16);
}

.um-week-chip--down {
  color: #b91c1c;
  background: rgba(239, 68, 68, 0.14);
}

.um-email {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  max-width: 16rem;
  text-transform: lowercase;
  overflow-wrap: anywhere;
}

.um-email__via {
  font-size: 0.7rem;
  font-style: italic;
  text-transform: none;
  color: var(--um-muted);
}

.um-col--email {
  width: 3.25rem;
  text-align: center;
}

.um-email-cell {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.um-email-ico {
  appearance: none;
  display: inline-grid;
  place-items: center;
  width: 2.15rem;
  height: 2.15rem;
  padding: 0;
  border-radius: 999px;
  border: 1px solid var(--um-line);
  background: color-mix(in srgb, var(--um-pine) 8%, transparent);
  color: var(--um-pine);
  cursor: pointer;
  transition: background 0.18s var(--um-ease), border-color 0.18s var(--um-ease),
    color 0.18s var(--um-ease);
}

.um-email-ico:hover,
.um-email-ico.is-open {
  background: color-mix(in srgb, var(--um-pine) 16%, transparent);
  border-color: color-mix(in srgb, var(--um-pine) 45%, var(--um-line));
}

.um-email-ico.is-via {
  color: var(--um-info);
}

.um-email-pop {
  position: fixed;
  z-index: 40;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  width: min(22rem, 70vw);
  padding: 0.65rem 0.7rem;
  border-radius: 12px;
  border: 1px solid var(--um-line);
  background: var(--surface-color, #fff);
  box-shadow: 0 12px 28px color-mix(in srgb, var(--um-slate) 18%, transparent);
  text-align: left;
}

.um-email-pop__addr {
  appearance: none;
  display: block;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: var(--um-pine);
  font: 600 0.82rem/1.35 var(--um-body);
  text-align: left;
  text-transform: lowercase;
  overflow-wrap: anywhere;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.um-email-pop__copy {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  align-self: flex-start;
  margin: 0;
  padding: 0.35rem 0.65rem;
  border-radius: 999px;
  border: 1px solid var(--um-line);
  background: color-mix(in srgb, var(--um-pine) 8%, transparent);
  color: var(--um-ink);
  font: 600 0.72rem/1 var(--um-body);
  cursor: pointer;
}

.um-email-pop__copy:hover {
  border-color: color-mix(in srgb, var(--um-pine) 40%, var(--um-line));
}

.um-muted {
  color: var(--um-muted);
}

.um-roles {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.um-roles__row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.um-roles__kids {
  font-size: 0.75rem;
  line-height: 1.35;
  color: var(--um-muted);
}

.um-roles__kids strong {
  color: var(--text-color);
  font-weight: 600;
}

.um-actions-cell {
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
}

.um-icon-btn {
  width: 2rem !important;
  height: 2rem !important;
}

.um-date {
  white-space: nowrap;
  font-size: 0.82rem;
  color: var(--um-slate);
}

/* ── Mobile cards ──────────────────────────────────────────────────── */
.um-cards {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.um-card {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  border-radius: 14px;
  border: 1px solid var(--um-line);
  background:
    linear-gradient(
      90deg,
      var(--um-rail, var(--um-pine)) 0 3px,
      transparent 3px
    ),
    color-mix(in srgb, var(--surface-color, #fff) 96%, transparent);
  box-shadow: 0 4px 12px color-mix(in srgb, var(--um-slate) 6%, transparent);
  overflow: hidden;
  transition: border-color 0.18s var(--um-ease), box-shadow 0.18s var(--um-ease);
}

.um-card.is-deleted {
  opacity: 0.72;
  --um-rail: var(--um-gone);
}

.um-card.is-awaiting,
.um-card.is-invited {
  --um-rail: var(--um-warn);
}

.um-card.is-active {
  --um-rail: var(--um-ok);
}

.um-card.is-inactive {
  --um-rail: var(--um-danger);
}

.um-card.is-expanded {
  border-color: color-mix(in srgb, var(--um-pine) 35%, var(--um-line));
  box-shadow: 0 8px 20px color-mix(in srgb, var(--um-slate) 10%, transparent);
}

.um-card__hit {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.55rem;
  width: 100%;
  margin: 0;
  padding: 0.55rem 0.55rem 0.55rem 0.7rem;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  font: inherit;
}

.um-card__hit:focus-visible {
  outline: 2px solid var(--um-pine);
  outline-offset: -2px;
}

.um-card__hit .um-avatar {
  width: 2.35rem;
  height: 2.35rem;
  font-size: 0.72rem;
  flex-shrink: 0;
}

.um-card__main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
}

.um-card__title {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
}

.um-card__name {
  margin: 0;
  flex: 1 1 auto;
  min-width: 0;
  font-size: 0.92rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.um-status-ico {
  flex-shrink: 0;
  width: 1.35rem;
  height: 1.35rem;
  display: grid;
  place-items: center;
  border-radius: 999px;
}

.um-status-ico--active {
  color: var(--um-ok);
  background: color-mix(in srgb, var(--um-ok) 14%, transparent);
}

.um-status-ico--inactive {
  color: var(--um-danger);
  background: color-mix(in srgb, var(--um-danger) 12%, transparent);
}

.um-status-ico--invited,
.um-status-ico--awaiting {
  color: var(--um-warn);
  background: color-mix(in srgb, var(--um-warn) 14%, transparent);
}

.um-status-ico--deleted {
  color: var(--um-gone);
  background: color-mix(in srgb, var(--um-gone) 14%, transparent);
}

.um-card__facts {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.25rem 0.55rem;
  min-width: 0;
}

.um-fact {
  display: inline-flex;
  align-items: center;
  gap: 0.22rem;
  min-width: 0;
  max-width: 100%;
  color: var(--um-muted);
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.15;
}

.um-fact svg {
  flex-shrink: 0;
  opacity: 0.85;
}

.um-fact em {
  font-style: normal;
  color: var(--text-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.um-fact--grow {
  flex: 1 1 7rem;
  min-width: 0;
}

.um-fact .um-rank {
  font-size: 0.68rem;
  padding: 0.05rem 0.32rem;
}

.um-card__roles {
  min-width: 0;
}

.um-card__roles .um-roles {
  gap: 0.2rem;
}

.um-card__roles .um-roles__row {
  gap: 0.25rem;
}

.um-card__roles .um-chip--role {
  font-size: 0.62rem;
  padding: 0.12rem 0.4rem;
  border-radius: 999px;
}

.um-card__roles .um-roles__kids {
  font-size: 0.68rem;
  line-height: 1.25;
}

.um-card__chev {
  flex-shrink: 0;
  color: var(--um-muted);
  transition: transform 0.2s var(--um-ease);
}

.um-card__chev.is-open {
  transform: rotate(180deg);
  color: var(--um-pine);
}

.um-card__drawer {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.65rem;
  padding: 0.55rem 0.7rem 0.7rem;
  border-top: 1px dashed color-mix(in srgb, var(--um-line) 80%, transparent);
  animation: um-drawer-in 0.18s var(--um-ease);
}

.um-card__email {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  padding: 0.55rem 0.65rem;
  border-radius: 10px;
  border: 1px solid var(--um-line);
  background: color-mix(in srgb, var(--um-pine) 5%, transparent);
  color: var(--um-muted);
}

.um-card__email svg {
  flex-shrink: 0;
  margin-top: 0.12rem;
}

.um-card__email-text {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  min-width: 0;
  flex: 1 1 auto;
}

.um-card__email-link {
  color: var(--um-pine);
  font-size: 0.86rem;
  font-weight: 600;
  line-height: 1.35;
  text-decoration: underline;
  text-underline-offset: 2px;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.um-card__drawer .um-actions-cell {
  width: 100%;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.15rem;
}

@keyframes um-drawer-in {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.um-empty {
  margin: 1.5rem 0;
  padding: 2rem 1.25rem;
  text-align: center;
  border-radius: 18px;
  border: 1px dashed var(--um-line);
  background: color-mix(in srgb, var(--um-pine) 4%, transparent);
}

.um-empty__title {
  margin: 0;
  font-family: var(--um-display);
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  color: var(--um-ink);
}

.um-empty__sub {
  margin: 0.45rem 0 0;
  color: var(--um-muted);
  font-size: 0.92rem;
}

.um-empty__action {
  margin-top: 1rem;
}

.um-pager {
  margin-top: 1rem;
}

@media (min-width: 900px) {
  .um-board {
    padding-left: max(1.25rem, env(safe-area-inset-left, 0px));
    padding-right: max(1.25rem, env(safe-area-inset-right, 0px));
  }

  .um-table-wrap {
    display: block;
  }

  .um-cards,
  .um-sort {
    display: none;
  }
}

@media (max-width: 899px) {
  .um-actions {
    width: 100%;
    margin-left: 0;
  }

  .um-btn {
    flex: 1 1 auto;
  }

  .um-sort {
    display: flex;
  }

  .um-hero__stats {
    width: 100%;
  }

  .um-stat {
    flex: 1 1 auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .um-board *,
  .um-board *::before,
  .um-board *::after {
    transition: none !important;
    animation: none !important;
  }
}

.dark-mode .um-board {
  --um-surface: color-mix(in srgb, var(--surface-color, #1c1d22) 90%, var(--brand-primary, #0877bc));
}

.dark-mode .um-search__input,
.dark-mode .um-sort__chip,
.dark-mode .um-table-wrap,
.dark-mode .um-card {
  background: color-mix(in srgb, var(--surface-color, #1c1d22) 96%, transparent);
}

.dark-mode .um-table thead th {
  background: color-mix(in srgb, var(--surface-color, #1c1d22) 88%, var(--um-pine));
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminLayout/UserManagement.css"],"names":[],"mappings":"AAEA,qFAAqF;AACrF;EACE,wCAAwC;EACxC,kEAAkE;EAClE,0EAA0E;EAC1E,sEAAsE;EACtE,+FAA+F;EAC/F,8FAA8F;EAC9F,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;EACzC,oEAAoE;EACpE,0DAA0D;;EAE1D,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd;;;;6CAI2C;EAC3C,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb;;+GAE6G;AAC/G;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;EAChC,2EAA2E;EAC3E,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd;;;;kCAIgC;AAClC;;AAEA;EACE,oEAAoE;EACpE,6EAA6E;AAC/E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oEAAoE;EACpE,8EAA8E;EAC9E,yEAAyE;AAC3E;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,uEAAuE;EACvE,kEAAkE;AACpE;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,uEAAuE;EACvE,kEAAkE;AACpE;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,uEAAuE;EACvE,kEAAkE;AACpE;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,uEAAuE;EACvE,kEAAkE;AACpE;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,uEAAuE;EACvE,kEAAkE;AACpE;;AAEA;EACE,6DAA6D;EAC7D,uEAAuE;EACvE,kEAAkE;AACpE;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC;;;;;;mEAMiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,oBAAoB;EACpB,gCAAgC;EAChC,iCAAiC;EACjC,wBAAwB;EACxB,oCAAoC;EACpC,aAAa;EACb,4EAA4E;AAC9E;;AAEA;EACE,oEAAoE;EACpE,yEAAyE;AAC3E;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;EAC7B,kCAAkC;EAClC,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB;iEAC+D;AACjE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,0EAA0E;AAC5E;;AAEA;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,oEAAoE;EACpE,8DAA8D;EAC9D,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,iCAAiC;EACjC,sBAAsB;EACtB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oEAAoE;EACpE,+DAA+D;EAC/D,oBAAoB;AACtB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,gCAAgC;EAChC,2EAA2E;EAC3E,2EAA2E;EAC3E,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,8EAA8E;EAC9E,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,4EAA4E;EAC5E,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,+DAA+D;AACjE;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,gCAAgC;EAChC,8DAA8D;EAC9D,qBAAqB;EACrB,eAAe;EACf;8BAC4B;AAC9B;;AAEA;;EAEE,+DAA+D;EAC/D,oEAAoE;AACtE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAgC;EAChC,sCAAsC;EACtC,4EAA4E;EAC5E,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,8DAA8D;EAC9D,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,mBAAmB;EACnB,gCAAgC;EAChC;;;;;;mEAMiE;EACjE,0EAA0E;EAC1E,gBAAgB;EAChB,8EAA8E;AAChF;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oEAAoE;EACpE,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,uCAAuC;EACvC,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,iEAAiE;AACnE;;AAEA;;EAEE,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,qBAAqB;EACrB,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,8BAA8B;EAC9B,0EAA0E;EAC1E,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gCAAgC;EAChC,8DAA8D;EAC9D,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,YAAY;AACd;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,8DAA8D;AAChE;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,0DAA0D;IAC1D,4DAA4D;EAC9D;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;;;IAGE,2BAA2B;IAC3B,0BAA0B;EAC5B;AACF;;AAEA;EACE,kGAAkG;AACpG;;AAEA;;;;EAIE,8EAA8E;AAChF;;AAEA;EACE,iFAAiF;AACnF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@600;700&family=IBM+Plex+Sans:wght@400;500;600&display=swap\");\n\n/* Club roster board — federation-sheet density on desktop, member cards on mobile. */\n.um-board {\n  --um-pine: var(--brand-primary, #0877bc);\n  --um-ink: var(--brand-primary-dark, var(--brand-primary, #0877bc));\n  --um-slate: color-mix(in srgb, var(--brand-primary, #0877bc) 38%, #1e293b);\n  --um-tape: color-mix(in srgb, #fff 90%, var(--brand-primary, #0877bc));\n  --um-surface: color-mix(in srgb, var(--surface-color, #fff) 92%, var(--brand-primary, #0877bc));\n  --um-line: color-mix(in srgb, var(--border-color, #e2e8f0) 70%, var(--brand-primary, #0877bc));\n  --um-muted: var(--text-secondary, #64748b);\n  --um-ok: #0f9f6e;\n  --um-warn: #d97706;\n  --um-info: #0284c7;\n  --um-danger: #dc2626;\n  --um-gone: #6b7280;\n  --um-ease: cubic-bezier(0.22, 1, 0.36, 1);\n  --um-display: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  --um-body: \"IBM Plex Sans\", Poppins, system-ui, sans-serif;\n\n  position: relative;\n  isolation: isolate;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0 auto;\n  padding:\n    max(0.75rem, env(safe-area-inset-top, 0px))\n    max(1rem, env(safe-area-inset-right, 0px))\n    calc(1.75rem + env(safe-area-inset-bottom, 0px))\n    max(1rem, env(safe-area-inset-left, 0px));\n  color: var(--text-color);\n  font-family: var(--um-body);\n}\n\n.um-board *,\n.um-board *::before,\n.um-board *::after {\n  box-sizing: border-box;\n}\n\n.um-board__glow {\n  pointer-events: none;\n  position: absolute;\n  z-index: -1;\n  inset: -6% -12% auto;\n  height: 160px;\n  opacity: 0.75;\n  background:\n    radial-gradient(50% 70% at 6% 20%, color-mix(in srgb, var(--um-pine) 16%, transparent) 0%, transparent 70%),\n    radial-gradient(36% 50% at 94% 0%, color-mix(in srgb, var(--um-pine) 10%, transparent) 0%, transparent 68%);\n}\n\n.um-hero {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 0.85rem 1.25rem;\n  margin-bottom: 1rem;\n}\n\n.um-hero__copy {\n  min-width: 0;\n  max-width: 42rem;\n}\n\n.um-hero__kicker {\n  margin: 0 0 0.2rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--um-muted);\n}\n\n.um-hero__title {\n  margin: 0;\n  font-family: var(--um-display);\n  font-size: clamp(1.85rem, 3.2vw, 2.55rem);\n  font-weight: 700;\n  line-height: 0.95;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--um-ink);\n}\n\n.um-hero__sub {\n  margin: 0.45rem 0 0;\n  font-size: 0.9rem;\n  line-height: 1.4;\n  color: var(--um-muted);\n  max-width: 36rem;\n}\n\n.um-hero__stats {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.um-stat {\n  appearance: none;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 5.5rem;\n  max-width: 8.5rem;\n  padding: 0.55rem 0.75rem;\n  border-radius: 12px;\n  border: 1px solid var(--um-line);\n  background: color-mix(in srgb, var(--surface-color, #fff) 88%, transparent);\n  backdrop-filter: blur(8px);\n  cursor: pointer;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  transition:\n    border-color 0.18s var(--um-ease),\n    background 0.18s var(--um-ease),\n    box-shadow 0.18s var(--um-ease),\n    transform 0.18s var(--um-ease);\n}\n\n.um-stat:hover {\n  border-color: color-mix(in srgb, var(--um-pine) 42%, var(--um-line));\n  background: color-mix(in srgb, var(--um-pine) 8%, var(--surface-color, #fff));\n}\n\n.um-stat:active {\n  transform: scale(0.98);\n}\n\n.um-stat.is-active {\n  border-color: color-mix(in srgb, var(--um-pine) 55%, var(--um-line));\n  background: color-mix(in srgb, var(--um-pine) 12%, var(--surface-color, #fff));\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--um-pine) 22%, transparent);\n}\n\n.um-stat--coaches {\n  border-color: color-mix(in srgb, #6d28d9 35%, var(--um-line));\n}\n\n.um-stat--coaches.is-active {\n  border-color: color-mix(in srgb, #6d28d9 55%, var(--um-line));\n  background: color-mix(in srgb, #6d28d9 12%, var(--surface-color, #fff));\n  box-shadow: 0 0 0 2px color-mix(in srgb, #6d28d9 22%, transparent);\n}\n\n.um-stat--competition {\n  border-color: color-mix(in srgb, #2563eb 35%, var(--um-line));\n}\n\n.um-stat--competition.is-active {\n  border-color: color-mix(in srgb, #2563eb 55%, var(--um-line));\n  background: color-mix(in srgb, #2563eb 12%, var(--surface-color, #fff));\n  box-shadow: 0 0 0 2px color-mix(in srgb, #2563eb 22%, transparent);\n}\n\n.um-stat--leisure {\n  border-color: color-mix(in srgb, #0f9f6e 35%, var(--um-line));\n}\n\n.um-stat--leisure.is-active {\n  border-color: color-mix(in srgb, #0f9f6e 55%, var(--um-line));\n  background: color-mix(in srgb, #0f9f6e 12%, var(--surface-color, #fff));\n  box-shadow: 0 0 0 2px color-mix(in srgb, #0f9f6e 22%, transparent);\n}\n\n.um-stat--health {\n  border-color: color-mix(in srgb, #d97706 35%, var(--um-line));\n}\n\n.um-stat--health.is-active {\n  border-color: color-mix(in srgb, #d97706 55%, var(--um-line));\n  background: color-mix(in srgb, #d97706 12%, var(--surface-color, #fff));\n  box-shadow: 0 0 0 2px color-mix(in srgb, #d97706 22%, transparent);\n}\n\n.um-stat--invited {\n  border-color: color-mix(in srgb, #0284c7 35%, var(--um-line));\n}\n\n.um-stat--form {\n  border-color: color-mix(in srgb, #9e2b2b 35%, var(--um-line));\n}\n\n.um-stat--form.is-active {\n  border-color: color-mix(in srgb, #9e2b2b 55%, var(--um-line));\n  background: color-mix(in srgb, #9e2b2b 10%, var(--surface-color, #fff));\n  box-shadow: 0 0 0 2px color-mix(in srgb, #9e2b2b 18%, transparent);\n}\n\n.um-stat--invited.is-active {\n  border-color: color-mix(in srgb, #0284c7 55%, var(--um-line));\n  background: color-mix(in srgb, #0284c7 12%, var(--surface-color, #fff));\n  box-shadow: 0 0 0 2px color-mix(in srgb, #0284c7 22%, transparent);\n}\n\n.um-stat__value {\n  font-family: var(--um-display);\n  font-size: 1.55rem;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: 0.02em;\n  color: var(--um-pine);\n}\n\n.um-stat__label {\n  margin-top: 0.25rem;\n  font-size: 0.64rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--um-muted);\n  line-height: 1.25;\n}\n\n.um-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 0.9rem;\n  padding: 0.7rem;\n  border-radius: 16px;\n  border: 1px solid var(--um-line);\n  background:\n    linear-gradient(\n      135deg,\n      color-mix(in srgb, var(--um-pine) 6%, transparent),\n      transparent 55%\n    ),\n    color-mix(in srgb, var(--surface-color, #fff) 92%, transparent);\n}\n\n.um-search {\n  position: relative;\n  flex: 1 1 14rem;\n  min-width: 0;\n}\n\n.um-search__icon {\n  position: absolute;\n  left: 0.85rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--um-muted);\n  font-size: 0.85rem;\n  pointer-events: none;\n}\n\n.um-search__input {\n  width: 100%;\n  height: 2.65rem;\n  padding: 0 0.9rem 0 2.35rem;\n  border-radius: 999px;\n  border: 1px solid var(--um-line);\n  background: var(--bg-color, #fff);\n  color: var(--text-color);\n  font: 500 0.92rem/1.2 var(--um-body);\n  outline: none;\n  transition: border-color 0.2s var(--um-ease), box-shadow 0.2s var(--um-ease);\n}\n\n.um-search__input:focus {\n  border-color: color-mix(in srgb, var(--um-pine) 55%, var(--um-line));\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--um-pine) 18%, transparent);\n}\n\n.um-search__input::placeholder {\n  color: var(--um-muted);\n  opacity: 0.85;\n}\n\n.um-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  margin-left: auto;\n}\n\n.um-btn {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-height: 2.55rem;\n  padding: 0.55rem 1rem;\n  border-radius: 999px;\n  border: 1px solid transparent;\n  font: 600 0.82rem/1 var(--um-body);\n  letter-spacing: 0.01em;\n  cursor: pointer;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: transform 0.18s var(--um-ease), background 0.18s var(--um-ease),\n    border-color 0.18s var(--um-ease), color 0.18s var(--um-ease);\n}\n\n.um-btn:active {\n  transform: scale(0.98);\n}\n\n.um-chip--form {\n  border: 1px solid #9e2b2b;\n  background: transparent;\n  color: #9e2b2b;\n  cursor: pointer;\n  font: inherit;\n  font-size: 12px;\n  padding: 2px 8px;\n  margin-top: 4px;\n}\n\n.um-chip--newcomer {\n  border: 0;\n  cursor: pointer;\n  background: #12362c;\n  color: #f3f6f4;\n  font: inherit;\n  font-size: 12px;\n  padding: 2px 8px;\n  margin-top: 4px;\n}\n\n.um-btn--primary {\n  background: var(--um-pine);\n  color: #fff;\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--um-pine) 28%, transparent);\n}\n\n.um-btn--primary:hover {\n  filter: brightness(1.05);\n  color: #fff;\n}\n\n.um-btn--ghost {\n  background: transparent;\n  border-color: var(--um-line);\n  color: var(--um-slate);\n}\n\n.um-btn--ghost:hover {\n  border-color: color-mix(in srgb, var(--um-pine) 40%, var(--um-line));\n  background: color-mix(in srgb, var(--um-pine) 8%, transparent);\n  color: var(--um-ink);\n}\n\n.um-sort {\n  display: none;\n  gap: 0.4rem;\n  width: 100%;\n  overflow-x: auto;\n  padding-bottom: 0.15rem;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.um-sort::-webkit-scrollbar {\n  display: none;\n}\n\n.um-sort__chip {\n  appearance: none;\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  min-height: 2rem;\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  border: 1px solid var(--um-line);\n  background: var(--bg-color, #fff);\n  color: var(--um-muted);\n  font: 600 0.75rem/1 var(--um-body);\n  cursor: pointer;\n}\n\n.um-sort__chip.is-active {\n  border-color: color-mix(in srgb, var(--um-pine) 45%, var(--um-line));\n  background: color-mix(in srgb, var(--um-pine) 12%, transparent);\n  color: var(--um-ink);\n}\n\n/* ── Desktop table ─────────────────────────────────────────────────── */\n.um-table-wrap {\n  display: none;\n  width: 100%;\n  overflow: auto;\n  border-radius: 18px;\n  border: 1px solid var(--um-line);\n  background: color-mix(in srgb, var(--surface-color, #fff) 94%, transparent);\n  box-shadow: 0 10px 28px color-mix(in srgb, var(--um-slate) 8%, transparent);\n  -webkit-overflow-scrolling: touch;\n}\n\n.um-table {\n  width: 100%;\n  min-width: 1080px;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: auto;\n}\n\n.um-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  padding: 0.85rem 0.9rem;\n  text-align: left;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--um-muted);\n  background: color-mix(in srgb, var(--surface-color, #fff) 88%, var(--um-pine));\n  border-bottom: 1px solid var(--um-line);\n  white-space: nowrap;\n}\n\n.um-table th.um-col--name,\n.um-table td.um-col--name {\n  min-width: 16rem;\n  width: 22%;\n  max-width: 22rem;\n}\n\n.um-table th.um-th--sort {\n  cursor: pointer;\n  user-select: none;\n}\n\n.um-table th.um-th--sort:hover {\n  color: var(--um-ink);\n}\n\n.um-th__inner {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n}\n\n.um-table tbody td {\n  padding: 0.85rem 0.9rem;\n  vertical-align: middle;\n  border-bottom: 1px solid color-mix(in srgb, var(--um-line) 70%, transparent);\n  font-size: 0.88rem;\n}\n\n.um-table tbody tr {\n  transition: background 0.18s var(--um-ease);\n}\n\n.um-table tbody tr:hover td {\n  background: color-mix(in srgb, var(--um-pine) 6%, transparent);\n}\n\n.um-table tbody tr.is-deleted {\n  opacity: 0.72;\n}\n\n.um-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\n.um-identity {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 0;\n}\n\n.um-avatar {\n  position: relative;\n  flex: 0 0 auto;\n  width: 2.55rem;\n  height: 2.55rem;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  font-family: var(--um-display);\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  color: #fff;\n  background: var(--um-pine);\n  box-shadow: 0 0 0 2px color-mix(in srgb, #fff 70%, transparent);\n}\n\n.um-avatar--awaiting,\n.um-avatar--invited {\n  background: var(--um-warn);\n}\n\n.um-avatar--deleted {\n  background: var(--um-gone);\n}\n\n.um-avatar__rank {\n  position: absolute;\n  right: -0.2rem;\n  bottom: -0.2rem;\n  min-width: 1.35rem;\n  height: 1.15rem;\n  padding: 0 0.28rem;\n  border-radius: 999px;\n  display: grid;\n  place-items: center;\n  font-family: var(--um-display);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: #fff;\n  border: 1.5px solid var(--bg-color, #fff);\n}\n\n.um-identity__text {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n}\n\n.um-identity__name {\n  margin: 0;\n  font-family: var(--um-display);\n  font-size: 1.12rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  line-height: 1.2;\n  color: var(--text-color);\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  overflow: hidden;\n  overflow-wrap: break-word;\n  word-break: normal;\n  hyphens: manual;\n}\n\n.um-identity-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.35rem;\n}\n\n.um-identity__meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n  padding-left: 3.3rem;\n}\n\n.um-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 1.25rem;\n  padding: 0.12rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  color: #fff;\n}\n\n.um-chip--awaiting {\n  background: var(--um-warn);\n}\n\n.um-chip--invited {\n  background: var(--um-info);\n}\n\n.um-chip--deleted {\n  background: var(--um-gone);\n}\n\n.um-chip--active {\n  background: var(--um-ok);\n}\n\n.um-chip--inactive {\n  background: var(--um-danger);\n}\n\n.um-guest-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-top: 0.3rem;\n}\n\n.um-chip--guest-visits {\n  background: rgba(40, 80, 120, 0.14);\n  color: #1e3a5f;\n}\n\n.um-chip--guest-license {\n  background: rgba(190, 40, 40, 0.16);\n  color: #b42318;\n  font-weight: 700;\n}\n\n.um-chip--guest-pending {\n  background: rgba(180, 120, 20, 0.18);\n  color: #8a5a00;\n}\n\n.um-chip--role {\n  background: var(--um-slate);\n}\n\n.um-rank {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 2.2rem;\n  padding: 0.28rem 0.55rem;\n  border-radius: 8px;\n  font-family: var(--um-display);\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  color: #fff;\n}\n\n.um-rank--a {\n  background: #0f9f6e;\n}\n\n.um-rank--b {\n  background: #2563eb;\n}\n\n.um-rank--c {\n  background: #d97706;\n}\n\n.um-rank--d,\n.um-rank--other {\n  background: #dc2626;\n}\n\n.um-points {\n  font-family: var(--um-display);\n  font-size: 1.05rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  color: var(--um-pine);\n}\n\n.um-points-wrap {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n\n.um-place {\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: var(--um-muted);\n  letter-spacing: 0.02em;\n}\n\n.um-week-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.1rem 0.45rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.um-week-chip--up {\n  color: #0f7a32;\n  background: rgba(16, 185, 129, 0.16);\n}\n\n.um-week-chip--down {\n  color: #b91c1c;\n  background: rgba(239, 68, 68, 0.14);\n}\n\n.um-email {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  max-width: 16rem;\n  text-transform: lowercase;\n  overflow-wrap: anywhere;\n}\n\n.um-email__via {\n  font-size: 0.7rem;\n  font-style: italic;\n  text-transform: none;\n  color: var(--um-muted);\n}\n\n.um-col--email {\n  width: 3.25rem;\n  text-align: center;\n}\n\n.um-email-cell {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.um-email-ico {\n  appearance: none;\n  display: inline-grid;\n  place-items: center;\n  width: 2.15rem;\n  height: 2.15rem;\n  padding: 0;\n  border-radius: 999px;\n  border: 1px solid var(--um-line);\n  background: color-mix(in srgb, var(--um-pine) 8%, transparent);\n  color: var(--um-pine);\n  cursor: pointer;\n  transition: background 0.18s var(--um-ease), border-color 0.18s var(--um-ease),\n    color 0.18s var(--um-ease);\n}\n\n.um-email-ico:hover,\n.um-email-ico.is-open {\n  background: color-mix(in srgb, var(--um-pine) 16%, transparent);\n  border-color: color-mix(in srgb, var(--um-pine) 45%, var(--um-line));\n}\n\n.um-email-ico.is-via {\n  color: var(--um-info);\n}\n\n.um-email-pop {\n  position: fixed;\n  z-index: 40;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  width: min(22rem, 70vw);\n  padding: 0.65rem 0.7rem;\n  border-radius: 12px;\n  border: 1px solid var(--um-line);\n  background: var(--surface-color, #fff);\n  box-shadow: 0 12px 28px color-mix(in srgb, var(--um-slate) 18%, transparent);\n  text-align: left;\n}\n\n.um-email-pop__addr {\n  appearance: none;\n  display: block;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: var(--um-pine);\n  font: 600 0.82rem/1.35 var(--um-body);\n  text-align: left;\n  text-transform: lowercase;\n  overflow-wrap: anywhere;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n\n.um-email-pop__copy {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  align-self: flex-start;\n  margin: 0;\n  padding: 0.35rem 0.65rem;\n  border-radius: 999px;\n  border: 1px solid var(--um-line);\n  background: color-mix(in srgb, var(--um-pine) 8%, transparent);\n  color: var(--um-ink);\n  font: 600 0.72rem/1 var(--um-body);\n  cursor: pointer;\n}\n\n.um-email-pop__copy:hover {\n  border-color: color-mix(in srgb, var(--um-pine) 40%, var(--um-line));\n}\n\n.um-muted {\n  color: var(--um-muted);\n}\n\n.um-roles {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.um-roles__row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.um-roles__kids {\n  font-size: 0.75rem;\n  line-height: 1.35;\n  color: var(--um-muted);\n}\n\n.um-roles__kids strong {\n  color: var(--text-color);\n  font-weight: 600;\n}\n\n.um-actions-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.2rem;\n}\n\n.um-icon-btn {\n  width: 2rem !important;\n  height: 2rem !important;\n}\n\n.um-date {\n  white-space: nowrap;\n  font-size: 0.82rem;\n  color: var(--um-slate);\n}\n\n/* ── Mobile cards ──────────────────────────────────────────────────── */\n.um-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.um-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  border-radius: 14px;\n  border: 1px solid var(--um-line);\n  background:\n    linear-gradient(\n      90deg,\n      var(--um-rail, var(--um-pine)) 0 3px,\n      transparent 3px\n    ),\n    color-mix(in srgb, var(--surface-color, #fff) 96%, transparent);\n  box-shadow: 0 4px 12px color-mix(in srgb, var(--um-slate) 6%, transparent);\n  overflow: hidden;\n  transition: border-color 0.18s var(--um-ease), box-shadow 0.18s var(--um-ease);\n}\n\n.um-card.is-deleted {\n  opacity: 0.72;\n  --um-rail: var(--um-gone);\n}\n\n.um-card.is-awaiting,\n.um-card.is-invited {\n  --um-rail: var(--um-warn);\n}\n\n.um-card.is-active {\n  --um-rail: var(--um-ok);\n}\n\n.um-card.is-inactive {\n  --um-rail: var(--um-danger);\n}\n\n.um-card.is-expanded {\n  border-color: color-mix(in srgb, var(--um-pine) 35%, var(--um-line));\n  box-shadow: 0 8px 20px color-mix(in srgb, var(--um-slate) 10%, transparent);\n}\n\n.um-card__hit {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 0.55rem;\n  width: 100%;\n  margin: 0;\n  padding: 0.55rem 0.55rem 0.55rem 0.7rem;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  font: inherit;\n}\n\n.um-card__hit:focus-visible {\n  outline: 2px solid var(--um-pine);\n  outline-offset: -2px;\n}\n\n.um-card__hit .um-avatar {\n  width: 2.35rem;\n  height: 2.35rem;\n  font-size: 0.72rem;\n  flex-shrink: 0;\n}\n\n.um-card__main {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n}\n\n.um-card__title {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.um-card__name {\n  margin: 0;\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 0.92rem;\n  font-weight: 700;\n  line-height: 1.2;\n  color: var(--text-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.um-status-ico {\n  flex-shrink: 0;\n  width: 1.35rem;\n  height: 1.35rem;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n}\n\n.um-status-ico--active {\n  color: var(--um-ok);\n  background: color-mix(in srgb, var(--um-ok) 14%, transparent);\n}\n\n.um-status-ico--inactive {\n  color: var(--um-danger);\n  background: color-mix(in srgb, var(--um-danger) 12%, transparent);\n}\n\n.um-status-ico--invited,\n.um-status-ico--awaiting {\n  color: var(--um-warn);\n  background: color-mix(in srgb, var(--um-warn) 14%, transparent);\n}\n\n.um-status-ico--deleted {\n  color: var(--um-gone);\n  background: color-mix(in srgb, var(--um-gone) 14%, transparent);\n}\n\n.um-card__facts {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.25rem 0.55rem;\n  min-width: 0;\n}\n\n.um-fact {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.22rem;\n  min-width: 0;\n  max-width: 100%;\n  color: var(--um-muted);\n  font-size: 0.72rem;\n  font-weight: 600;\n  line-height: 1.15;\n}\n\n.um-fact svg {\n  flex-shrink: 0;\n  opacity: 0.85;\n}\n\n.um-fact em {\n  font-style: normal;\n  color: var(--text-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.um-fact--grow {\n  flex: 1 1 7rem;\n  min-width: 0;\n}\n\n.um-fact .um-rank {\n  font-size: 0.68rem;\n  padding: 0.05rem 0.32rem;\n}\n\n.um-card__roles {\n  min-width: 0;\n}\n\n.um-card__roles .um-roles {\n  gap: 0.2rem;\n}\n\n.um-card__roles .um-roles__row {\n  gap: 0.25rem;\n}\n\n.um-card__roles .um-chip--role {\n  font-size: 0.62rem;\n  padding: 0.12rem 0.4rem;\n  border-radius: 999px;\n}\n\n.um-card__roles .um-roles__kids {\n  font-size: 0.68rem;\n  line-height: 1.25;\n}\n\n.um-card__chev {\n  flex-shrink: 0;\n  color: var(--um-muted);\n  transition: transform 0.2s var(--um-ease);\n}\n\n.um-card__chev.is-open {\n  transform: rotate(180deg);\n  color: var(--um-pine);\n}\n\n.um-card__drawer {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.65rem;\n  padding: 0.55rem 0.7rem 0.7rem;\n  border-top: 1px dashed color-mix(in srgb, var(--um-line) 80%, transparent);\n  animation: um-drawer-in 0.18s var(--um-ease);\n}\n\n.um-card__email {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  padding: 0.55rem 0.65rem;\n  border-radius: 10px;\n  border: 1px solid var(--um-line);\n  background: color-mix(in srgb, var(--um-pine) 5%, transparent);\n  color: var(--um-muted);\n}\n\n.um-card__email svg {\n  flex-shrink: 0;\n  margin-top: 0.12rem;\n}\n\n.um-card__email-text {\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.um-card__email-link {\n  color: var(--um-pine);\n  font-size: 0.86rem;\n  font-weight: 600;\n  line-height: 1.35;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.um-card__drawer .um-actions-cell {\n  width: 100%;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.15rem;\n}\n\n@keyframes um-drawer-in {\n  from {\n    opacity: 0;\n    transform: translateY(-4px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.um-empty {\n  margin: 1.5rem 0;\n  padding: 2rem 1.25rem;\n  text-align: center;\n  border-radius: 18px;\n  border: 1px dashed var(--um-line);\n  background: color-mix(in srgb, var(--um-pine) 4%, transparent);\n}\n\n.um-empty__title {\n  margin: 0;\n  font-family: var(--um-display);\n  font-size: 1.6rem;\n  font-weight: 700;\n  letter-spacing: 0.03em;\n  text-transform: uppercase;\n  color: var(--um-ink);\n}\n\n.um-empty__sub {\n  margin: 0.45rem 0 0;\n  color: var(--um-muted);\n  font-size: 0.92rem;\n}\n\n.um-empty__action {\n  margin-top: 1rem;\n}\n\n.um-pager {\n  margin-top: 1rem;\n}\n\n@media (min-width: 900px) {\n  .um-board {\n    padding-left: max(1.25rem, env(safe-area-inset-left, 0px));\n    padding-right: max(1.25rem, env(safe-area-inset-right, 0px));\n  }\n\n  .um-table-wrap {\n    display: block;\n  }\n\n  .um-cards,\n  .um-sort {\n    display: none;\n  }\n}\n\n@media (max-width: 899px) {\n  .um-actions {\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .um-btn {\n    flex: 1 1 auto;\n  }\n\n  .um-sort {\n    display: flex;\n  }\n\n  .um-hero__stats {\n    width: 100%;\n  }\n\n  .um-stat {\n    flex: 1 1 auto;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .um-board *,\n  .um-board *::before,\n  .um-board *::after {\n    transition: none !important;\n    animation: none !important;\n  }\n}\n\n.dark-mode .um-board {\n  --um-surface: color-mix(in srgb, var(--surface-color, #1c1d22) 90%, var(--brand-primary, #0877bc));\n}\n\n.dark-mode .um-search__input,\n.dark-mode .um-sort__chip,\n.dark-mode .um-table-wrap,\n.dark-mode .um-card {\n  background: color-mix(in srgb, var(--surface-color, #1c1d22) 96%, transparent);\n}\n\n.dark-mode .um-table thead th {\n  background: color-mix(in srgb, var(--surface-color, #1c1d22) 88%, var(--um-pine));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
